import { CardContent } from "@mui/material";
import { MprcCard } from "components";
import { MprcContainer } from "components/MprcContainer";
import { MprcRecordInfo } from "components/MprcRecordInfo";
import { AuditLogEntityType, RecordInfoDto } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { AuditLogDialog } from "views/common/AuditLog/AuditLogDialog";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    devplanId: string;
    name: string;
    recordInfo: RecordInfoDto;
}

////////////////////////////////////////////////////////////////////////////

export const EditDevPlanViewFooter: React.FC<IProps> = ({ devplanId, name, recordInfo }) => {

    const [dialog, setDialog] = useState<any>(null);

    return (
        <MprcContainer>
            {dialog}
            <MprcCard>
                <CardContent>
                    <MprcRecordInfo recordInfo={recordInfo}
                        onHistoryClick={
                            () => {
                                setDialog(
                                    <AuditLogDialog
                                        title={name}
                                        entityType={AuditLogEntityType.DevPlan}
                                        entityKey={[devplanId]}
                                        onClose={() => setDialog(null)}
                                    />
                                );
                            }
                        }
                    >
                    </MprcRecordInfo>
                </CardContent>
            </MprcCard>
        </MprcContainer>
    );
};
